import Route from '@core/components/Route';
import List from '@shared/components/List';
import ListItem from '@shared/components/ListItem';
import { FC, memo } from 'react';

import { LEGAL_LINKS } from '../assets/data/legal-links';
import { COLOR } from '../types/theme';
import { colorToCss } from '../utils/theme';

const LIST_SX = { borderTop: `1px solid ${colorToCss(COLOR.Dark3)}` };
const LIST_PADDING = { top: '2.5rem' };
const LIST_ITEM_MARGIN = { x: '0.5em', y: '0' };
const LIST_ITEM_SX = { display: 'inline-list-item', fontSize: '0.75rem', lineHeight: '0.75rem' };
const ROUTE_SX = {
  '&:hover': { color: colorToCss(COLOR.Gray3) },
  color: 'text.secondary',
  fontSize: '0.75rem',
  lineHeight: '0.75rem',
};

const FooterLegal: FC = () => (
  <List
    itemProps={{
      margin: LIST_ITEM_MARGIN,
      sx: LIST_ITEM_SX,
      variant: 'body2',
    }}
    padding={LIST_PADDING}
    sx={LIST_SX}
  >
    {Object.values(LEGAL_LINKS).map(({ text, url }) => (
      <ListItem key={url}>
        <Route href={url} sx={ROUTE_SX} variant='body2'>
          {text}
        </Route>
      </ListItem>
    ))}
  </List>
);

export default memo(FooterLegal);
